import { render } from "./permissions_component.vue?vue&type=template&id=997f29c4&scoped=true"
import script from "./permissions_component.vue?vue&type=script&lang=js"
export * from "./permissions_component.vue?vue&type=script&lang=js"

import "./permissions_component.vue?vue&type=style&index=0&id=997f29c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997f29c4"]])

export default __exports__